import React from 'react';

function ChamadoTypeField({ value, onChange, tipos = [], id = 'chamado-tipo' }) {
    return (
        <div className="chamado-create-field">
            <label htmlFor={id}>Tipo do chamado</label>
            <select
                id={id}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Selecione o tipo...</option>
                {tipos.map((t) => (
                    <option key={t.id} value={t.id}>{t.nome}</option>
                ))}
            </select>
        </div>
    );
}

export default ChamadoTypeField;
